import React from 'react';
import Alert from "../../../components/pages/grid/Alert/Alert";

const AlertGridPage = () => {
    return <Alert />
};

export default AlertGridPage;
